/* eslint-disable arrow-body-style */
import clsx from 'clsx';

import { fallbackContainer } from './style.css';

type ErrorFallbackProps = {
  message?: string;
  className?: string;
}

const ErrorFallback = (
  { message = 'Something went wrong', className }: ErrorFallbackProps
) => {
  return (
    <div className={clsx(fallbackContainer, className)}>{message}</div>
  );
};

export default ErrorFallback;
